import styled from 'styled-components';
import { palette } from 'styled-theme';

export const MobileMenuWrapper = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1100; /* Above topbar and sidebar */
  background: ${palette('secondary', 0)};
  color: #fff;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  .mobile-menu-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 56px;
    padding: 0 8px 0 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    flex-shrink: 0;
  }

  .mobile-menu-title {
    font-size: 18px;
    font-weight: 500;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .mobile-menu-close {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    border: 0;
    background: transparent;
    color: #fff;
    font-size: 22px;
    cursor: pointer;
  }

  .mobile-menu-items {
    display: flex;
    flex-direction: column;
    padding: 8px 0 24px;
  }

  .mobile-menu-item {
    display: flex;
    align-items: center;
    gap: 16px;
    width: 100%;
    min-height: 52px;
    padding: 0 20px;
    border: 0;
    background: transparent;
    color: ${palette('grayscale', 6)};
    font-size: 17px;
    text-align: left;
    text-decoration: none;
    cursor: pointer;

    &.active {
      color: ${palette('primary', 0)};
    }

    &:active {
      background: rgba(255, 255, 255, 0.08);
    }
  }

  .mobile-menu-chevron {
    margin-left: auto;
    font-size: 14px;
    transition: transform 0.2s ease;

    &.open {
      transform: rotate(180deg);
    }
  }

  .mobile-menu-children {
    display: flex;
    flex-direction: column;
    padding-bottom: 8px;
    background: rgba(0, 0, 0, 0.15);
  }

  .mobile-menu-child {
    display: flex;
    align-items: center;
    min-height: 46px;
    padding: 0 20px 0 56px; /* Line up with parent label, past the icon */
    color: ${palette('grayscale', 6)};
    font-size: 16px;
    text-decoration: none;

    &.active {
      color: ${palette('primary', 0)};
      font-weight: 500;
    }

    &:active {
      background: rgba(255, 255, 255, 0.08);
    }
  }
`;
